import SimpleTextElement from './simple-text-element';

export {
  SimpleTextElement
}



// WEBPACK FOOTER //
// src/common/form-elements/simple-text-element-folder/index.js